import { useEffect } from 'react'

import type { MetaModel } from '../types/metaModel'
import { useFetchMetaModel } from '../uiModels/api/metaModel/useFetchMetaModel'

type Props = {
  layerId: string | null
  onDidFetch: (layerId: string | null, metaModel: MetaModel) => void
}

export const MetaModelFetcher = ({ layerId, onDidFetch }: Props) => {
  const { data: metaModel } = useFetchMetaModel(layerId)

  useEffect(() => {
    if (metaModel) {
      onDidFetch(layerId, metaModel)
    }
  }, [layerId, metaModel, onDidFetch])

  return null
}
